var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOloBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 47,
    viewBox: "0 0 76 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2582 31.738C19.709 31.738 23.3094 28.0443 23.3094 23.4897C23.3094 18.9428 19.709 15.25 15.2582 15.25C10.8075 15.25 7.20703 18.9428 7.20703 23.4897C7.20703 28.0443 10.8075 31.738 15.2582 31.738ZM15.2597 7.87109C23.6856 7.87109 30.5194 14.8657 30.5194 23.4896C30.5194 32.1135 23.6856 39.1081 15.2597 39.1081C6.83389 39.1081 0 32.1135 0 23.4896C0 14.8657 6.83389 7.87109 15.2597 7.87109Z",
    fill: "#2D96FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.6254 31.738C56.1747 31.738 52.5742 28.0443 52.5742 23.4897C52.5742 18.9428 56.1747 15.25 60.6254 15.25C65.0762 15.25 68.6766 18.9428 68.6766 23.4897C68.6766 28.0443 65.0762 31.738 60.6254 31.738ZM60.6269 7.87109C52.2011 7.87109 45.3672 14.8657 45.3672 23.4896C45.3672 32.1135 52.2011 39.1081 60.6269 39.1081C69.0527 39.1081 75.8866 32.1135 75.8866 23.4896C75.8866 14.8657 69.0527 7.87109 60.6269 7.87109Z",
    fill: "#2D96FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8242 47H42.0289V0H34.8242V47Z",
    fill: "#2D96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOloBlue);
export default __webpack_public_path__ + "static/media/logo-Olo-blue.d8559efb4a08c71713e69fef9f67ed70.svg";
export { ForwardRef as ReactComponent };